import type { User } from '../context/User';

/**
 * Fetch the currently-logged-in user to prefill name/email.
 *
 * eb-ui: `sdkRequest('/users/me/')` → `GET /api/v3/users/me/` (Core, via the
 * `/api/v3` baseUrl). In Valkyrie the client must not hit Core directly, so we
 * GET the app's OWN same-origin BFF route, which forwards to Core server-side.
 * Path is overridable per consuming app (default `/api/users/me/`).
 */
const DEFAULT_USER_PATH = '/api/users/me/';

export const getUser = async (userPath?: string): Promise<User | null> => {
    const response = await fetch(userPath ?? DEFAULT_USER_PATH, {
        method: 'GET',
        credentials: 'same-origin',
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch user: ${response.status}`);
    }

    return (await response.json()) as User;
};
